import React, { useState } from 'react';
import Dots from '../Dots/Dots';
import Image from './Image';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import styles from './Slider.module.css';
import { Grid } from '@mui/material';

const Slider = ({ imageSlider }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [slidenumber, setSlideNumber] = useState(0);

  React.useEffect(() => {
    const slide = setInterval(() => {
      if (slidenumber === -100 * (imageSlider.length - 1)) {
        setSlideNumber(0);
        setActiveIndex(0);
      } else {
        setSlideNumber(slidenumber - 100);
        setActiveIndex(prev => prev + 1);
      }
    }, 10000);
    return () => clearInterval(slide);
  }, [slidenumber, imageSlider.length]);

  const handleClickOnDot = index => {
    setSlideNumber(-100 * index);
    setActiveIndex(index);
  };

  const AllSlider = slide => {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          // height: '1024px',
        }}>
        <Image src={slide.urls} />
        <Typography
          variant="h2"
          color="primary"
          component="h2"
          align="center"
          sx={{
            width: ' 100%',
            mt: '40px',
            fontSize: '28px',
            fontWeight: 600,
            height: '80px',
            flexWrap: 'wrap',
            fontFamily: 'Inter',
          }}>
          {slide.title}
        </Typography>
        <Typography
          variant="h3"
          component="h3"
          align="center"
          sx={{
            width: '100%',
            mt: '12px',
            zIndex: 10,
            fontSize: '18px',
            fontFamily: 'Inter',
            fontStyle: 'normal',
            fontWeight: 'normal',
            lineHeight: '24px',
          }}>
          {slide.description}
        </Typography>
      </Box>
    );
  };
 

  return (
    <Grid className={styles.slider} data-testid="todo-3">
      {imageSlider.map(slide => {
        return (
          <Grid item key={slide.id} sx={{ minWidth: '100%' }}>
            <Box
              component="div"
              className={styles.slide}
              style={{
                transform: `translateX(${slidenumber}%)`
              }}>
              {AllSlider(slide)}
            </Box>
            <Dots
              activeIndex={activeIndex}
              imageSlider={imageSlider}
              handleClickOnDot={handleClickOnDot}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default Slider;
